import type { Directive, DirectiveBinding } from 'vue'
import { usePermissionStore } from '@/stores/permission'

function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
  const store = usePermissionStore()
  const value = binding.value

  let hasPermission = false

  if (typeof value === 'string') {
    hasPermission = store.hasPermission(value)
  } else if (Array.isArray(value)) {
    hasPermission = store.hasAnyPermission(...value)
  }

  if (!hasPermission) {
    // 隐藏元素（不移除，以支持后续权限动态变化）
    el.style.display = 'none'
  } else {
    el.style.display = ''
  }
}

export const vPermission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  }
}
